export default {
  LIST_FETCHED: 'TROPHIES_FETCHED',
  LIST_LOAD: 'TROPHIES_LOAD',
  ITEM_DETAIL: 'TROPHIES_DETAIL',
  BUTTON_LOAD: 'TROPHIES_BUTTON_LOAD',
};
